require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./kriterien-schliesstage-geschl-jahr-3-6-j-2022-23.json") })
        }
      }, "path---kriterien-schliesstage-geschl-jahr-3-6-j-2022-23");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---kriterien-schliesstage-geschl-jahr-3-6-j-2022-23!./.cache/json/kriterien-schliesstage-geschl-jahr-3-6-j-2022-23.json
// module id = 1102
// module chunks = 231608221292675